<template>
  <PageContent>
    <StepsV2 :step="4" />
    <PanelV2 type="w6" title="Take a selfie with your ID" @nextClick="commitData">
      <template v-slot:title-solt>
        <BdoProgress :step="1" :total="2" />
      </template>
      <template v-slot:content-solt>
        <IdCardUpload photoType="idCard" @uploadData="uploadData" :photoData="formData" />
      </template>
    </PanelV2>
  </PageContent>
</template>

<script>
import IdCardUpload from "../pages/common/IdCardUpload.vue";
import API from "@/api";
export default {
  name: "IndividualJ",
  pRouter: "IndividualI",
  components: {
    IdCardUpload,
  },
  data() {
    return {
      formData: {idCardiUrl: ''},
    };
  },
  methods: {
    uploadData(val) {
      this.formData.idCardiUrl = val;
    },
    commitData() {
      if (this.formData.idCardiUrl) {
        const data = this.formatCommitData({...this.formData})

        API.addBdoProcess({
          ...data
        }).then(res => {
          if (res.success) {
            this.toNext()
          }
        })
      } else {
        this.showMessageTip('Upload your selfie with ID')
      }
    },
  },
};
</script>


<style lang="scss" scoped>
</style>
